import Vue from 'vue'
import Vuex, { Store } from 'vuex'
import Plugins from '@plugins/index'
import { VueSitecoreMixin, SitecoreExtend } from '@lib/vue-scexpeditor'
import directives from '../03.javascript/directives'
import components from '../03.javascript/components'
import StoreConfig from './store'

// Jquery ui CSS
import 'webpack-jquery-ui/css'

// The main CSS entry point, it will be placed in a separate file.
import '../02.styles/hsia.scss'

if (!window.Sitecore) {
  document.querySelectorAll('a').forEach(anchor => {
    const hasSearchParams = anchor.href.includes('?')
    const replaceParams = hasSearchParams ? ['?', '&'] : ['', '']
    const windowSearchParams = window.location.search.replace(...replaceParams)
    const isExternal = !anchor.href.includes(window.location.host)
    let prefix = anchor.href
    if (prefix && !isExternal) {
      anchor.href = prefix + windowSearchParams
    }
  })
}

// Install plugins
Object.values(Plugins).forEach((Plugin) => Vue.use(Plugin))

// Add the Vuex plugin.
Vue.use(Vuex)

// Create store
const store = new Store(StoreConfig)

// Bind all global directives.
directives.forEach((directive) => Vue.directive(directive.name, directive))

// Register all components globally.
Object.values(components).forEach((component) => Vue.component(component.name, component))

// Mixin for sitecore's ExpEditor compatibility
Vue.use(VueSitecoreMixin)

// The root Vue instance.
const root = new Vue({
  store,
  mixins: []
})

// Extend sitecore's ExpEditor javascript for rendering vue components on update
Vue.use(SitecoreExtend, root)

// Mount the Vue application.
root.$mount('#app')
